// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from "../../../../store";
import ProUserSearch from './components/ProUserSearch'
import VTooltip from "v-tooltip";
import '../../../css/tooltip.css'
import {VueMasonryPlugin} from "vue-masonry";

Vue.use(VTooltip);
Vue.use(VueMasonryPlugin);
Vue.config.productionTip = false;

/* eslint-disable no-new */
const vueApp = new Vue({
  el: '#proUserSearch',
  store,
  components: { ProUserSearch },
})



// WEBPACK FOOTER //
// ./src/main/frontend/vue/js/modules/pro/search/user/index.js